"use strict";

import { nanoid } from "nanoid";

const uniqueId = function() {
    return `${Math.floor(new Date().getTime() / 1000)}${nanoid()}`;
}

export default uniqueId;